import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { AgGridModule } from "ag-grid-angular";
import { MatComponentsModule } from "src/app/mat-components.module";
import { ChartsModule } from "src/app/components/shared/charts/charts.module";

import { SubtaskDrilldownPanelComponent } from "./components/subtask-drilldown-panel/subtask-drilldown-panel.component";
import { SubtaskMiniKanbanComponent } from "./components/subtask-mini-kanban/subtask-mini-kanban.component";
import { SubtaskCompactCardComponent } from "./components/subtask-compact-card/subtask-compact-card.component";
import { TaskProgressIndicatorComponent } from "./components/task-progress-indicator/task-progress-indicator.component";
import { GlobalCaseSidebarComponent } from "./components/global-case-sidebar/global-case-sidebar.component";

// The full Case Management board + its feature subtree. These were declared in
// DirectModule; they now live here so the SAME <app-task-management-wf> can be
// rendered both on the Case Management page (DirectModule) and inside the global
// drawer hosted in the topnav (DashboardModule).
import { TaskManagementWfComponent } from "./page/task-management-wf/task-management-wf.component";
import { AvatarCellRendererComponent } from "./components/cell-renderers/avatar-cell-renderer.component";
import { StatusCellRendererComponent } from "./components/cell-renderers/status-cell-renderer.component";
import { PriorityCellRendererComponent } from "./components/cell-renderers/priority-cell-renderer.component";
import { ActionsCellRendererComponent } from "./components/cell-renderers/actions-cell-renderer.component";
import { TaskManagementDialogComponent } from "./components/task-management-dialog/task-management-dialog.component";
import { TaskDetailContentComponent } from "./components/task-detail-content/task-detail-content.component";
import { SubtaskFormComponent } from "./components/subtask-form/subtask-form.component";
import { SubtaskListComponent } from "./components/subtask-list/subtask-list.component";
import { SubtaskItemComponent } from "./components/subtask-item/subtask-item.component";

/**
 * Shared module for the Case Management feature.
 *
 * Holds the board ({@link TaskManagementWfComponent}), its dialog + cell
 * renderers, and the subtask sidebar subtree. Both {@link DirectModule} (for the
 * Case Management page + task-detail page) and {@link DashboardModule} (for the
 * global drawer hosted in the topnav) import this module, so the exact same
 * components render in both places.
 *
 * It imports nothing from `DirectModule`/`DashboardModule` (only shared/3rd-party
 * modules), so importing it from either side introduces no circular dependency.
 */
@NgModule({
  declarations: [
    // Subtask sidebar subtree
    SubtaskDrilldownPanelComponent,
    SubtaskMiniKanbanComponent,
    SubtaskCompactCardComponent,
    TaskProgressIndicatorComponent,
    // Board + dialog + cell renderers
    TaskManagementWfComponent,
    AvatarCellRendererComponent,
    StatusCellRendererComponent,
    PriorityCellRendererComponent,
    ActionsCellRendererComponent,
    TaskManagementDialogComponent,
    TaskDetailContentComponent,
    SubtaskFormComponent,
    SubtaskListComponent,
    SubtaskItemComponent,
    // Global drawer host
    GlobalCaseSidebarComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DragDropModule,
    AgGridModule,
    MatComponentsModule,
    ChartsModule,
  ],
  exports: [
    // Consumed by DirectComponent (Case Management page)
    TaskManagementWfComponent,
    // Consumed by TaskDetailPageComponent (DirectModule task-detail route)
    TaskDetailContentComponent,
    // Subtask sidebar subtree (kept exported for any external consumer)
    SubtaskDrilldownPanelComponent,
    SubtaskMiniKanbanComponent,
    SubtaskCompactCardComponent,
    TaskProgressIndicatorComponent,
    // Global drawer host (rendered by the topnav)
    GlobalCaseSidebarComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TaskPanelModule {}
